import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var jQuery:any;
declare var $ :any;
declare var polyvPlayer :any;
declare var window :any;


@Component({
  selector: 'app-learning-map-introduction',
  templateUrl: './learning-map-introduction.component.html',
  styleUrls: ['./learning-map-introduction.component.css',]
})

export class LearningMapIntroductionComponent implements OnInit, AfterViewInit{
  @Input() learningPathMetaId : any
  // @Input() learningPath :  any
  @Output() onButtonClick = new EventEmitter<any>();
  constructor(private commonService:CommonService,
                private apiService:ApiService,
                private route: ActivatedRoute,
                private router: Router) { }

  ngOnInit() {
    this.commonService.initPage({
        backgroundColor:'white'
    });
    window['s2j_onPlayOver'] = function () {
      $('#video-intro').fadeOut(200);
      $('.closeBtn').click();
      $('.closeBtn').fadeOut(200);
      // $('#wrapAll').fadeIn(200);
    };
    console.log(123)
  }

  ngAfterViewInit(){
    var player = polyvPlayer({
      wrap: '#video-intro',
      width: '100vw',
      height: '100vh',
      vid: '352e2664d8ac0401e9e2b433d7dd7ca5_3',
      // autoplay: true,
      // skinLocation: 0,
      ban_history_time: 'on',
      // hideSwitchPlayer: true,
      hideRepeat: true,
      // forceH5: true,
      flashvars: {'autoplay': true}
      // audioMode: false
    });
    player.toggleFullscreen();
  }

  onBtnClick(){
    this.onButtonClick.emit();
    this.apiService.ajax({
      'type':'post',
      'url':'/api/learningtour/guidePageShown'
    }).subscribe(result=>{});
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-map-introduction/learning-map-introduction.component.ts